import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { routes } from '@/router';
import { RouteType } from '@/models';

@Component
export default class NavigationItem extends Vue {
  @Prop() route: RouteType;
  private isActive = false;
  private classes = '';
  private navigationItemClass = { color: 'grey lighten-1' };

  @Watch('$route', { deep: true })
  onRouteChange(): void {
    this.setClassName();
  }

  setClassName(): void {
    const { name } = this.route;
    const childrenRoutes = routes.filter(route => route.showInSideBarAsPage === name);
    const isActive = this.$route.name === name || !!childrenRoutes.find(route => route.name === this.$route.name);
    this.isActive = isActive;
    this.classes = isActive ? 'navigation-item--active' : '';
    this.navigationItemClass = isActive ?
      { color: '' } :
      { color: 'navigation-item__icon-inactive' };
  }

  mounted(): void {
    this.setClassName();
  }
}
